<template>
    <el-dialog
        title="Détails des dernières requêtes d'inspection"
        :visible.sync="showModal"
        width="70%"
        append-to-body
        @close="showModal = false"
    >
        <el-table :data="inspections">
            <el-table-column
                prop="plate"
                label="Plaque"
            ></el-table-column>
            <el-table-column
                label="Date de la requête d'inspection"
            >
                <template slot-scope="scope">
                    <span>
                        {{ scope.row.scheduled_date_start | moment('DD/MM/YYYY') }} - {{ scope.row.scheduled_date_end | moment('DD/MM/YYYY') }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                label="Statut"
            >
                <template slot-scope="scope">
                    <div>{{inspectionStatus(scope.row)}}</div>
                </template>
            </el-table-column>
        </el-table>
        <span slot="footer">
            <el-button @click="showModal = false">Fermer</el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {

    components: {

    },

    props: {

    },

    data: function(){
        return {
            inspections: [],
            showModal: false
        };
    },

    computed: {

    },

    mounted: function(){

    },

    methods: {
        inspectionStatus(inspection) {
            if (inspection.client_has_answered) {
                if (inspection.vehicle_available === true) {
                    return 'Acceptée';
                } else {
                    return 'Refusée';
                }
            } else {
                if (inspection.rescheduled === true) {
                    return 'Re-plannifiée';
                } else {
                    return 'En attente de réponse';
                }
            }
        },
        open(vehicle, inspections) {
            this.$set(this, 'inspections', inspections.slice(0, 3));
            this.showModal = true;
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Vehicles/inspectionsDetailsDialog.vue